import React from "react";
import Logo from "../img/about.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Circle from "../img/circle.svg";
import "../App.scss";
import { Link } from "react-router-dom";

function About() {
  return (
    <div className="about">
      <div className="container">
        <div className="row">
          <div className="about-image-mobile">
            <div className="col-lg-6">
              <div className="about-area">
                <img className="about-image" src={Logo} alt="images" />
              </div>
            </div>
          </div>
          <div className="about-image-desktop col-lg-6">
            <div className="about-area">
              <img className="about-image" src={Logo} alt="images" />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="about-text text-left mt-4 animated animatedFadeInUp fadeInUp">
              <h4>About</h4>
              <img
                className="about-image"
                src={Circle}
                alt="images"
                className="circle1"
              />
              <h1 className="about-title">
                We Create Brands, Build Products and Maketing Things.
              </h1>
              <p className="about-description">
                We're a team of design practitioners who transform organisation
                through education.{" "}
              </p>
              <Link to="/About">
                <button className="btn bodybutton">
                  About Us &nbsp; &nbsp;
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    className="bodybutton-icon"
                  />
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
